//CYBERSECURITY BASICS page component
//*******************************************************************
//*******************************************************************
//Importing Dependencies:
//external and package dependencies 
import $ from 'jquery'
import Popper from 'popper.js'
import React from 'react'
import {graphql, Link} from 'gatsby'
//component dependencies
import Heading from '../../components/heading'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import PageHeader from '../../components/PageHeader'
import FullWidthImage from '../../components/FullWidthImage'
import TextBlock from '../../components/textblock'
import Header from '../../components/Header'
import ContentsTable from '../../components/ContentsTable'
import ContentBlock from '../../components/ContentBlock'
import ContentSection from '../../components/ContentSection'
import ContentGridNew from '../../components/ContentGridNew'
import BodySection from '../../components/BodySection'
//import ToggleNewTest from '../../components/ToggleNewTest'
import Helmet from "react-helmet"
//*******************************************************************
//******************************************************************* 
const cyberBasicsPage = ({data}) => {
    
    const cyberBasics = data.cybersecurity_best_practices.edges    
    
    return (   
        
        <div>
            
             <Helmet>
                   <title>NJCCIC Cyber Security Best Practices</title>
                    <meta name="description" content=" The NJCCIC recommends putting in a place a few simple cybersecurity controls that can greatly reduce risk"/>
            </Helmet>
            <Heading/>
            
            <Navbar/>
        
            {cyberBasics.map(({ node: {page_title, introductory_text, subheader, content_group, headers, image, image_2, content_group_basics, content_group_identity_theft, content_group_account_security} }) => (
        
                <div class="container-fluid">
        
                    <PageHeader divClass="containerWidth" elementClass="pageHeader centerText" title={page_title}/>
                                        
                    <div class="container containerWidth">
                        
                        <div class="row">
        
                            <TextBlock elementClass="standardText introPadding" text={introductory_text}/>   
                            
                        </div>
                    
                    </div>
        
                    <ContentsTable testClass="testClass container containerWidth grid2Container" elementClass="col-12 col-sm-6 col-md-4 grid2 blocks block2 block2Alt" dangerousClass="standardText blockText margin btnWidth" headerStyles="header contentTitle" data={content_group} iconId="iconsGroup"/>
        
                    <FullWidthImage id="basicsBanner" src={image}/>
                    
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[0].section_name} id="the-basics"/>
                    
                    <BodySection data={content_group_basics} />
                    
                    <br/>
                    <br/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[1].section_name} id="account-security"/>
                    
                    <BodySection data={content_group_account_security} />
                    
                    <br/>
                    <br/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[2].section_name} id="identity-theft"/>
                    
                    <BodySection data={content_group_identity_theft} />
                                        
                </div>  
        
            ))}     
            
            

            {/*{data_array.map(({ node: {content_title, anchor_id, content_group, seo_title} }) => (
                
                <div class="container-fluid">
                
                    <ToggleNew id={anchor_id} divClass="container containerWidth" elementClass="col-12 standardText section" heading={content_title} headerStyles="header leftHeader clickableHeader pointer" subHeaderStyles="standardText leftSubHeader" data={content_group} />
                
                {/*<ContentSection dataTarget={content_title} testClass="test" divClass="container containerWidth" elementClass="col-12 standardText section" heading={content_title} headerStyles="header leftHeader clickableHeader" subHeaderStyles="standardText subHeader leftSubHeader" data={content_group} />
                    
                </div>
                
            ))}*/}
        
            <Footer/>       
            
        </div>  
    
    )    
    
}
//*******************************************************************
//*******************************************************************
export const query = graphql`
    query {
        cybersecurity_best_practices: allButterPage(filter: { slug: { eq: "cybersecurity-best-practices" } }) {
            edges {
                node {
                    seo_title
                    page_title
                    introductory_text
                    image
                    image_alt_text
                    image_2
                    subheader 
                    content_group {
                        section_name
                        text
                        icon
                    }
                    headers {
                        section_name
                    }
                    content_group_basics {
                        icon
                        section_name
                        preview_text
                        toggle_target
                        main_text
                    }
                    content_group_identity_theft {
                        icon
                        section_name
                        preview_text
                        toggle_target
                        main_text
                    }
                    content_group_account_security {
                        icon
                        section_name
                        preview_text
                        toggle_target
                        main_text
                    }
                }               
            }
        }
    }
`
export default cyberBasicsPage       
//*****************************************************************************************************************************************************
//*****************************************************************************************************************************************************